import { memo } from 'react';
import PropTypes from 'prop-types';
import style from './textarea.module.scss';

// Multi-line input styled to match PLInput. Used where a single-line
// input is too cramped for the expected content (e.g. T&C with a
// 300-char limit). CharCounter lives externally in the label row,
// mirroring the PLInput pattern — keeps the field clean.
function Textarea({
  inputId,
  value,
  placeholder,
  rows = 4,
  maxLength = 500,
  onInputChange,
  readOnly,
}) {
  const handleChange = e => {
    const next = e.target.value;
    if (next.length <= maxLength) onInputChange(next);
  };

  return (
    <div className={style.wrapper}>
      <textarea
        id={inputId}
        className={style.textarea}
        value={value || ''}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        readOnly={readOnly}
        onChange={handleChange}
        autoComplete="off"
      />
    </div>
  );
}

Textarea.propTypes = {
  inputId: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  onInputChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

export default memo(Textarea);
